export const REQUEST_FAQ_LIST = "REQUEST_FAQ_LIST"
export const REQUEST_FAQ = "REQUEST_FAQ"